module.exports = __webpack_public_path__ + "img/emoji_03.a3a3abdf.png";